export const LANDING_COPY_MAX_LENGTH = 4000;

export type LandingCopy = {
  tagline: string;
  headline: string;
  headlineAccent: string;
  intro: string;
  assistantIntro: string;
  cta: string;
  footer: string;
};

export const DEFAULT_LANDING_COPY: LandingCopy = {
  tagline: "The Goldie Hawn Foundation",
  headline: "Welcome to Your AI-Powered MindUP Teaching Assistant",
  headlineAccent: "Teaching",
  intro:
    "MindUP is a brain-focused program from The Goldie Hawn Foundation that teaches children how their brains work and how to manage stress and emotions. The program helps students build focus, resilience, and readiness to learn.",
  assistantIntro:
    "Use MindUP's AI Teaching Assistant to explore brain basics, classroom activities, mindful breathing exercises, and full-length or mini lesson plans.",
  cta: "Ready to Begin?",
  footer:
    "© Copyright 2025 The Goldie Hawn Foundation | MindUP. All rights reserved.",
};

export const LANDING_COPY_KEYS = [
  "tagline",
  "headline",
  "headlineAccent",
  "intro",
  "assistantIntro",
  "cta",
  "footer",
] as const satisfies ReadonlyArray<keyof LandingCopy>;
